import { Outlet, createFileRoute } from "@tanstack/react-router";

import { PERMISSIONS } from "@/constants/permissions";
import { APP_ROUTES_TO } from "@/utils/routes";

export const Route = createFileRoute(APP_ROUTES_TO.INCIDENTS)({
    component: IncidentsLayout,
    staticData: {
        config: {
            breadcrumb: { title: "incidents", to: APP_ROUTES_TO.INCIDENTS },
            title: "incidents",
        },
        permissions: [PERMISSIONS.CALL_SVC_ADMIN_BASE],
    },
});

function IncidentsLayout() {
    return <Outlet />;
}
